module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/dearfoams-cf106bc1449a934834f0c5645ad4be7e.svg";